export default __webpack_public_path__ + "117f495aa026788f40ec59e3df2aefa0.png";